import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed, LeagueNews, LeagueNewsType, UntilDestroy } from '@mtgame/core';
import { NewsDetailService } from '@core/services/news-detail.service';
import { takeUntil } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';
import { getLeagueVideoListRoute } from '@config/routes';

@UntilDestroy
@Component({
  selector: 'mtg-league-video-detail',
  templateUrl: './league-video-detail.component.html',
  styleUrls: ['./league-video-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueVideoDetailComponent implements OnInit, OnDestroy{
  news: LeagueNews;

  constructor(
    private seoService: SeoService,
    private newsDetailService: NewsDetailService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.newsDetailService.news$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(news => {
        this.news = news;
        this.seoService.setData({
          title: news.title,
          image: news.picture.path,
          description: news.detailText.replace(/<[^>]*>/g, '').slice(0, 300)
        });
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    this.newsDetailService.dispose();
  }

  getVideoListRoute(): string[] {
    return getLeagueVideoListRoute();
  }
}
